module.exports = __webpack_public_path__ + "img/to.5cba98ad.svg";